var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import classnames from 'classnames';
import styles from './Modal.scss';
import { colors, positions } from './ModalConstants';
import WixComponent from '../BaseComponents/WixComponent';

var Modal = function (_WixComponent) {
  _inherits(Modal, _WixComponent);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: 'render',
    value: function render() {
      var props = this.props;

      var justifyContent = positions[props.horizontalPosition];
      var alignItems = positions[props.verticalPosition];
      var maxHeight = props.scrollableContent ? props.maxHeight || '100vh' : 'auto';

      var modalStyles = {
        overlay: {
          // Overriding defaults
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 11 + (props.zIndex || 0),
          backgroundColor: null, // null disables the property, use css instead
          // Overriding defaults - END
          display: 'flex',
          justifyContent: justifyContent,
          alignItems: alignItems,
          overflowY: props.scrollable ? 'auto' : 'hidden'
        },
        content: {
          // Overriding defaults
          border: 'none',
          overflowY: props.scrollableContent ? 'auto' : 'initial',
          overflowX: props.scrollableContent ? 'hidden' : 'initial',
          maxHeight: maxHeight,
          WebkitOverflowScrolling: 'touch',
          outline: 'none',
          borderRadius: props.borderRadius,
          padding: '0px',
          boxShadow: '0 0 14px 0 rgba(22, 45, 60, 0.3)',
          // Overriding defaults - END
          backgroundColor: 'transparent',
          marginBottom: '0px'
        }
      };

      var modalClasses = styles.modal + ' ' + styles[props.theme];
      var portalClassName = classnames(styles.portal, _defineProperty({}, styles.portalNonScrollable, !props.scrollable));

      return React.createElement(
        ReactModal,
        {
          portalClassName: portalClassName,
          isOpen: props.isOpen,
          shouldCloseOnOverlayClick: props.shouldCloseOnOverlayClick,
          onRequestClose: props.onRequestClose,
          onAfterOpen: props.onAfterOpen,
          style: modalStyles,
          className: modalClasses,
          contentLabel: props.contentLabel,
          closeTimeoutMS: props.closeTimeoutMS
        },
        props.children
      );
    }
  }]);

  return Modal;
}(WixComponent);

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  contentLabel: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(Object.keys(colors)),
  children: PropTypes.any,
  zIndex: PropTypes.number,
  shouldCloseOnOverlayClick: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  horizontalPosition: PropTypes.oneOf(Object.keys(positions)),
  verticalPosition: PropTypes.oneOf(Object.keys(positions)),
  closeTimeoutMS: PropTypes.number,
  scrollable: PropTypes.bool,
  scrollableContent: PropTypes.bool
};
Modal.defaultProps = {
  onOk: function onOk() {},
  borderRadius: 0,
  theme: colors.blue,
  shouldCloseOnOverlayClick: false,
  horizontalPosition: 'center',
  verticalPosition: 'center',
  closeTimeoutMS: 500,
  scrollable: true,
  scrollableContent: false
};


export default Modal;
//# sourceMappingURL=Modal.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Modal/Modal.js